var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup33(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "59px",
    viewBox: "0 0 58 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5C52F506-63E0-4802-84A0-23AF1DF8778F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JN-Generation-Letter---Concepts-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Page--Image-Updated-v1-Alt-New-Copy-2",
    transform: "translate(-1053.000000, -284.000000)",
    stroke: "#05314D",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Condo-Image-Alt1",
    transform: "translate(75.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(456.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(500.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7494795,32.8611068 C35.7494795,35.015189 34.0027397,36.7619288 31.8486575,36.7619288 C29.6938082,36.7619288 27.9478356,35.015189 27.9478356,32.8611068 C27.9478356,30.7062575 29.6938082,28.9602849 31.8486575,28.9602849 C34.0027397,28.9602849 35.7494795,30.7062575 35.7494795,32.8611068 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.514389,24.2381041 C48.9243616,26.794926 49.7275397,29.7345425 49.7275397,32.861337 C49.7275397,42.7349808 41.7226082,50.7399123 31.8489644,50.7399123 L27.5822247,50.7399123",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6874411,17.3077589 C19.7677699,13.0686356 25.5004822,10.4312658 31.8484274,10.4312658 C44.2359342,10.4312658 54.2783452,20.4729096 54.2783452,32.8611836 C54.2783452,45.2486904 44.2359342,55.2903342 31.8484274,55.2903342",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0070466,27.3579178 C10.4051836,25.6549041 10.9974027,24.4052603 11.758389,22.8771507",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92235616,37.7979288 C9.59249315,36.2675178 9.41912329,35.0577644 9.41912329,33.4283945",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7898959,50.3390137 C15.7132932,48.6666849 13.9412384,46.632274 12.5696219,44.3309041",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.8486575,
    y1: 55.2904877,
    x2: 13.4952329,
    y2: 55.2904877,
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.220537,
    y1: 40.9863233,
    x2: 4.52157808,
    y2: 40.9863233,
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.6586082,
    y1: 20.0488438,
    x2: 4.23099178,
    y2: 20.0488438,
    id: "Stroke-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.635737,
    y1: 30.4230356,
    x2: 0.192010959,
    y2: 30.4230356,
    id: "Stroke-19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.2462027,
    y1: 16.3012932,
    x2: 50.9866959,
    y2: 12.2600877,
    id: "Stroke-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.6063123,
    y1: 29.892263,
    x2: 43.5302575,
    y2: 20.2863452,
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.4022795,
    y1: 10.5534685,
    x2: 52.9371836,
    y2: 13.8444274,
    id: "Stroke-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5005918,5.79899178 L27.6737425,5.79899178 C26.1318247,5.79899178 24.8699068,4.53707397 24.8699068,2.99515616 C24.8699068,1.45323836 26.1318247,0.191320548 27.6737425,0.191320548 L35.9625096,0.191320548 C37.5044274,0.191320548 38.7663452,1.45323836 38.7663452,2.99515616 C38.7663452,4.53707397 37.5044274,5.79899178 35.9625096,5.79899178 L34.6829479,5.79899178",
    id: "Stroke-27"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.953611,
    y1: 5.92111781,
    x2: 28.953611,
    y2: 10.5537753,
    id: "Stroke-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.6827178,
    y1: 5.92111781,
    x2: 34.6827178,
    y2: 10.5537753,
    id: "Stroke-31"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33);
export default __webpack_public_path__ + "static/media/Group 33.d8412b048b9bcc89313e93e1c12c54de.svg";
export { ForwardRef as ReactComponent };